<div class="row align-items-center">
  <a (click)="abrirModal()">
    <button
      class="boton_volver"
      data-toggle="tooltip"
      data-placement="top"
      title="VOLVER"
      alt="VOLVER"
    >
      <i class="bi bi-chevron-left mr-2"></i>
      Volver a histórico de integraciones
    </button>
  </a>
</div>

<div class="row mt-5 align-items-center">
  <div class="hr-amarillo mr-3"></div>
  <h6 class="mb-0 h6-text">Buscar asignaturas a integrar:</h6>
</div>
<div class="pb-5 pt-4">
  <div class="row mt-4">
    <div class="col-3">
      <label class="label-form" for="asignatura"
        >Sigla asignatura <span class="required"> (Obligatorio)</span></label
      >
      <ng-select
        [notFoundText]="'No se encontraron resultados'"
        [loadingText]="'Buscando...'"
        placeholder="Ingresar sigla asignatura"
        [loading]="loadingSigla"
        [items]="filtroAsignaturas.listado"
        bindLabel="siglaIdSap"
        bindValue="idSeccion"
        [virtualScroll]="true"
        (scrollToEnd)="_integracionSharedService.endScrollSigla(this,searchValueSigla)"
        (change)="changeSiglaAsignatura($event)"
        (search)="onSearchSigla($event)"
        (clear)="limpiarFiltros()"
        [(ngModel)]="filtroSigla"
        #selectSigla
      >
      </ng-select>
    </div>
    <div class="col-2 centrar_iconos_botones">
      <button
        class="boton-buscar"
        data-toggle="tooltip"
        data-placement="top"
        title="BUSCAR"
        alt="BUSCAR"
        [disabled]="validarCampo()"
        (click)="busqueda()"
      >
        <i class="bi bi-search"></i>
      </button>
      <button
        class="boton-secundario tamanio_iconos-boton boton-limpiar"
        data-toggle="tooltip"
        data-placement="top"
        title="LIMPIAR"
        alt="LIMPIAR"
        (click)="limpiarFiltros()"
        *ngIf="integracionForm.get('siglaAsignatura')?.value != ''"
      >
        <i class="bi bi-x"></i>
      </button>
    </div>
  </div>
</div>

<div class="mb-5" *ngIf="mostrarResultados">
  <div class="form-check">
    <input
      class="form-check-input"
      type="radio"
      name="asignaturas"
      [id]="integracionForm.get('siglaAsignatura')?.value.siglaIdSap"
      (change)="
        asignaturaSeleccionada(integracionForm.get('siglaAsignatura')?.value)
      "
    />
    <label
      [for]="integracionForm.get('siglaAsignatura')?.value.siglaIdSap"
      class="form-check-label ml-2"
      >{{
        integracionForm.get("siglaAsignatura")?.value.sigla +
          " - " +
          integracionForm.get("siglaAsignatura")?.value.descripcion
      }}</label
    >
  </div>
</div>

<mat-horizontal-stepper
  class="form-container"
  (selectionChange)="onStepChange($event)"
  linear
  *ngIf="mostrarStepper"
  #stepper
  [animationDuration]="'0'"
>
  <mat-step [completed]="selectedIndex >= 0" label="Buscar curso Blackboard">
    <form
      [formGroup]="form2"
      (ngSubmit)="onSubmit()"
      class="pl-4 pr-5 pb-5 pt-4 row"
    >
      <div class="col-4">
        <label class="label-form" for="instancia"
          >Blackboard <span class="required"> (Obligatorio)</span></label
        >
        <select
          name="instancia"
          class="form-control select_criterios"
          id="instancia"
          formControlName="blackboard"
        >
          <option
            value="1"
            *ngFor="let instancia of instancias"
            [value]="instancia.id"
            [selected]="instancia.preseleccionado === 1"
          >
            {{ instancia.descripcion }}
          </option>
        </select>
        <mat-error
          *ngIf="form2.get('blackboard')?.hasError('required') && isSubmited"
          >Campo es <strong>obligatorio</strong></mat-error
        >
      </div>
      <div class="col-3">
        <label class="label-form" for="escuela"
          >ID de curso <span class="required"> (Obligatorio)</span></label
        >
        <input
          type="text"
          class="form-control select_criterios"
          placeholder="Ingresa curso"
          aria-describedby="basic-addon2"
          formControlName="idCurso"
          maxlength="50"
        />
        <mat-error
          *ngIf="form2.get('idCurso')?.hasError('required') && isSubmited"
          >Campo es <strong>obligatorio</strong></mat-error
        >
        <mat-hint
          class="input-hint"
          [ngStyle]="{
            'margin-left': calcularPorcentaje(form2.get('idCurso')?.value)
          }"
          >{{ form2.get("idCurso")?.value?.trim().length }}/50</mat-hint
        >
      </div>

      <div class="col-12 alinear-btn mt-5">
        <button
          class="boton-primario"
          data-toggle="tooltip"
          data-placement="top"
          title="SIGUIENTE"
          alt="SIGUIENTE"
          type="submit"
        >
          SIGUIENTE
        </button>
        <button
          type="button"
          mat-button
          matStepperNext
          hidden
          id="btn-siguiente"
        >
          Next
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step
    [completed]="selectedIndex >= 1"
    label="Seleccionar curso Blackboard"
  >
    <div>
      <table
        *ngIf="!renderTableCursos"
        [dtOptions]="dtOptions"
        datatable
        class="row-border hover table-striped display nowrap"
        aria-describedby="tabla cursos"
      >
        <thead class="header_tabla">
          <tr>
            <th>Id de curso</th>
            <th>Nombre del curso</th>
            <th>Blackboard</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td style="width: 100%">Procesando...</td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <table
        id="tabla-cursos"
        *ngIf="renderTableCursos"
        [dtOptions]="dtOptions"
        datatable
        class="row-border hover display nowrap mt-3"
        aria-describedby="tabla cursos"
        style="border: 1px solid #979797; border-radius: 4px"
      >
        <thead class="header_tabla">
          <tr>
            <th style="padding-left: 3em">Id de curso</th>
            <th style="padding-left: 10em">Nombre del curso</th>
            <th style="padding-left: 6em">Blackboard</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let curso of listaCursos" class="noBackground">
            <td class="py-0">
              <p
                class="celda"
                data-toggle="tooltip"
                data-placement="top"
                [title]="curso.cursoId"
                style="padding: 1em 1em 1em 3em"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  name="curso"
                  [id]="curso.cursoId"
                  checked
                  style="margin-top: 0.4em"
                />
                <label [for]="curso.cursoId" class="form-check-label ml-2">{{
                  curso.cursoId
                }}</label>
              </p>
            </td>
            <td class="py-0">
              <p
                class="celda"
                data-toggle="tooltip"
                data-placement="top"
                [title]="curso.nombre"
                style="padding-left: 9.2em"
              >
                {{ curso.nombre }}
              </p>
            </td>
            <td class="py-0">
              <p
                class="celda"
                data-toggle="tooltip"
                data-placement="top"
                [title]="curso.instancia"
                style="padding-left: 5.2em"
              >
                {{ curso.instancia }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-12 alinear-btn mt-5">
      <button
        mat-button
        matStepperPrevious
        class="boton-secundario mr-3"
        data-toggle="tooltip"
        data-placement="top"
        title="ATRÁS"
        alt="ATRÁS"
      >
        Atrás
      </button>
      <button
        class="boton-primario"
        data-toggle="tooltip"
        data-placement="top"
        title="SIGUIENTE"
        alt="SIGUIENTE"
        (click)="avanzarStep3()"
      >
        SIGUIENTE
      </button>
      <button
        type="button"
        mat-button
        matStepperNext
        hidden
        id="btn-siguiente2"
      >
        Next
      </button>
    </div>
  </mat-step>

  <mat-step
    [completed]="selectedIndex >= 2"
    label="Alinear e integrar calificaciones"
  >
    <div class="mr-5 ml-5">
      <div class="row mt-3 align-items-center">
        <div class="hr-amarillo mr-3"></div>
        <h6 class="mb-0">
          Asocie esta alineación a uno o más periodos académicos
        </h6>
      </div>
      <div class="row mt-4">
        <div class="col-4 periodo-container">
          <div class="col-8">
            <label class="label-form row label-container" for="periodo"
              >Periodo <span class="required"> (Obligatorio)</span>
              <div
                id="icono-periodo"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="grey"
                  class="bi bi-info-circle"
                  viewBox="0 0 16 16"
                  style="margin-left: 1rem; margin-bottom: 2px"
                >
                  <path
                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
                  />
                  <path
                    d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
                  />
                </svg>
              </div>
              <div
                class="triangle"
              ></div>
              <div
                [id]="'cstm-popover'"
                class="cstm-popover arrow_box"
              >
                Si no encuentras un periodo académico, es por que aún no ha sido
                creado
              </div>
            </label>
            <select
              name="periodo"
              id="periodo"
              class="form-control select_criterios"
              [(ngModel)]="periodoSeleccionado"
              (ngModelChange)="resetearDragAndDrop()"
            >
              <option [value]="-1" hidden selected>Seleccionar</option>
              <option
                [value]="index"
                *ngFor="let periodo of periodos; let index = index"
                [disabled]="periodo.integracionVigente"
                [ngClass]="{
                  'periodo-deshabilitado': periodo.integracionVigente
                }"
                data-toggle="tooltip"
                data-placement="top"
                [title]="
                  periodo.integracionVigente
                    ? 'Este periodo ya cuenta con una integración vigente'
                    : ''
                "
              >
                {{ periodo.siglaPeriodo }}
              </option>
            </select>
          </div>
          <div class="col-2">
            <button
              class="boton-buscar boton-periodo"
              data-toggle="tooltip"
              data-placement="top"
              title="BUSCAR"
              alt="BUSCAR"
              (click)="buscarPonderacion()"
              [disabled]="periodoSeleccionado === -1"
            >
              <i class="bi bi-search"></i>
            </button>
          </div>
        </div>
        <div class="col-8 alerta-container" *ngIf="mostrarAlerta">
          <i
            class="bi bi-exclamation-triangle-fill tamanio_iconos-boton mr-2"
          ></i>
          <p class="texto-alerta alerta-ponderacion">
            Este periodo no cuenta con sus ponderaciones configuradas.
            <span
              class="texto-subrayado"
              (click)="redirigirPonderar()"
              (onKeyUp)="redirigirPonderar()"
              >Ponderar</span
            >
          </p>
        </div>
      </div>
      <div class="row mt-5 align-items-center">
        <div class="hr-amarillo mr-3 hr-amarillo-mensaje"></div>
        <p class="mb-0 text-h6">
          Para integrar las calificaciones, arrastre las calificaciones
          disponibles de la COLUMNA C, hacia la COLUMNA B (calificaciones de
          Blackboard), para que coincidan con las de la COLUMNA A (de Portal de
          Calificaciones). Puede alinear la cantidad de calificaciones que
          considere necesarias.
        </p>
      </div>
      <div class="dragAndDrop-container mt-5">
        <div class="titulosContainer" #titulosContainer>
          <div class="tituloA titulo">
            <p class="titulo-columna">COLUMNA A</p>
            <mat-card class="custom-card">
              <mat-card-header class="custom-card-header custom-card-header-A">
                <mat-card-title
                  >Asignatura:
                  <b>{{
                    integracionForm.get("siglaAsignatura")?.value.sigla
                  }}</b></mat-card-title
                >
              </mat-card-header>
              <mat-card-content class="custom-card-body">
                <p>Calificaciones de Portal de Calificaciones</p>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="tituloB titulo">
            <p class="titulo-columna">COLUMNA B</p>
            <mat-card class="custom-card">
              <mat-card-header
                class="custom-card-header custom-card-header-B text-center"
              >
                <mat-card-title
                  >Asignatura:
                  <b>{{
                    nombreCursoBB + " (" + siglaCursoBB + ")"
                  }}</b></mat-card-title
                >
              </mat-card-header>
              <mat-card-content class="custom-card-body">
                <p>Selección de calificaciones de Blackboard a integrar</p>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="tituloC titulo">
            <p class="titulo-columna">COLUMNA C</p>
            <mat-card class="custom-card custom-card-C">
              <mat-card-content class="custom-card-body">
                <p>Calificaciones disponibles de Blackboard</p>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <div class="listaContainers" #listaContainers>
          <div class="listaA lista">
            <mat-card
              class="custom-card custom-card-lista"
              *ngFor="let prueba of pruebas"
              [ngClass]="{ 'custom-card-lista-disabled': deshabilitado }"
            >
              <mat-card-content class="custom-card-list-body">
                <p class="nota-lista">{{ prueba }}</p>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="listaB lista">
            <div
              *ngFor="let evaluacion of evaluacionesAsignadas; let i = index"
            >
              <div
                cdkDropList
                [cdkDropListData]="evaluacion.evaluacion"
                [cdkDropListConnectedTo]="connectedDropLists"
                (cdkDropListDropped)="drop($event, i + evaluaciones.length)"
                [id]="'cdk-drop-list-' + (i + evaluaciones.length).toString()"
              >
                <mat-card
                  class="custom-card"
                  cdkDrag
                  [cdkDragDisabled]="
                    evaluacion.evaluacion[0].nombre === '' || deshabilitado
                  "
                  [ngClass]="{
                    'custom-card-lista': evaluacion.evaluacion[0].nombre !== '',
                    'custom-card-lista-empty':
                      evaluacion.evaluacion[0].nombre === '',
                    'custom-card-lista-disabled': deshabilitado
                  }"
                >
                  <mat-card
                    class="custom-card-preview custom-card-lista card-preview"
                    *cdkDragPreview
                  >
                    <mat-card-content class="custom-card-list-body">
                      <p style="font-family: LatoRegular, sans-serif">
                        Actividad
                      </p>
                      <p class="evaluacion-texto-preview">
                        {{ evaluacion.evaluacion[0].nombre }}
                      </p>
                      <span
                        >({{ evaluacion.evaluacion[0].puntaje }} Puntos)</span
                      >
                    </mat-card-content>
                  </mat-card>
                  <mat-card-content
                    class="custom-card-list-body"
                    *ngIf="evaluacion.evaluacion[0].nombre != ''"
                  >
                    <p style="font-family: LatoRegular, sans-serif">
                      Actividad
                    </p>
                    <p class="evaluacion-texto">
                      {{ evaluacion.evaluacion[0].nombre }}
                    </p>
                    <span>({{ evaluacion.evaluacion[0].puntaje }} Puntos)</span>
                  </mat-card-content>
                  <mat-card-content
                    class="custom-card-list-body lista-vacia"
                    *ngIf="evaluacion.evaluacion[0].nombre === ''"
                  >
                    <p></p>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
          <div class="listaC lista">
            <div *ngFor="let evaluacion of evaluaciones; let i = index">
              <div
                cdkDropList
                [cdkDropListData]="evaluacion.evaluacion"
                [cdkDropListConnectedTo]="connectedDropLists"
                (cdkDropListDropped)="drop($event, i, 'evaluacionesSort')"
                [id]="'cdk-drop-list-' + i.toString()"
              >
                <mat-card
                  class="custom-card"
                  cdkDrag
                  [cdkDragDisabled]="
                    evaluacion.evaluacion[0].nombre === '' || deshabilitado
                  "
                  [ngClass]="{
                    'custom-card-lista': evaluacion.evaluacion[0].nombre !== '',
                    'custom-card-lista-empty':
                      evaluacion.evaluacion[0].nombre === '',
                    'custom-card-lista-disabled': deshabilitado
                  }"
                >
                  <mat-card
                    class="custom-card-preview custom-card-lista card-preview"
                    *cdkDragPreview
                  >
                    <mat-card-content class="custom-card-list-body">
                      <p style="font-family: LatoRegular, sans-serif">
                        Actividad
                      </p>
                      <p class="evaluacion-texto-preview">
                        {{ evaluacion.evaluacion[0].nombre }}
                      </p>
                      <span
                        >({{ evaluacion.evaluacion[0].puntaje }} Puntos)</span
                      >
                    </mat-card-content>
                  </mat-card>
                  <mat-card-content
                    class="custom-card-list-body"
                    *ngIf="evaluacion.evaluacion[0].nombre != ''"
                  >
                    <p style="font-family: LatoRegular, sans-serif">
                      Actividad
                    </p>
                    <p class="evaluacion-texto">
                      {{ evaluacion.evaluacion[0].nombre }}
                    </p>
                    <span>({{ evaluacion.evaluacion[0].puntaje }} Puntos)</span>
                  </mat-card-content>
                  <mat-card-content
                    class="custom-card-list-body lista-vacia"
                    *ngIf="evaluacion.evaluacion[0].nombre === ''"
                  >
                    <p></p>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 alinear-btn mt-5">
      <button
        mat-button
        matStepperPrevious
        class="boton-secundario mr-3"
        data-toggle="tooltip"
        data-placement="top"
        title="ATRÁS"
        alt="ATRÁS"
        (click)="limpiarStep3()"
      >
        Atrás
      </button>
      <button
        class="boton-primario"
        data-toggle="tooltip"
        data-placement="top"
        title="CONFIRMAR INTEGRACIÓN"
        alt="CONFIRMAR INTEGRACIÓN"
        (click)="mostrarMensajeConfirmacion()"
        [disabled]="deshabilitado || deshabilitarBtnCrear()"
      >
        CONFIRMAR INTEGRACIÓN
      </button>
    </div>
  </mat-step>

  <!-- Sobreescritura de iconos -->
  <ng-template matStepperIcon="complete">
    <ng-container *ngIf="selectedIndex === 0 || selectedIndex === 1">
      <span>1</span>
    </ng-container>
  </ng-template>

  <ng-template matStepperIcon="editable">
    <ng-container *ngIf="selectedIndex === 1">
      <span>2</span>
    </ng-container>
  </ng-template>

  <ng-template matStepperIcon="complete">
    <ng-container *ngIf="selectedIndex === 2">
      <span>3</span>
    </ng-container>
  </ng-template>
</mat-horizontal-stepper>

<!-- MODAL ELIMINAR -->
<button
  id="modal-salir"
  class="btn d-none"
  data-toggle="modal"
  data-target="#salir"
>
  CERRAR Salir Integración
</button>
<div
  class="modal fade"
  id="salir"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          title="CERRAR"
          alt="CERRAR"
        >
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row align-items-center my-3 mx-4 text-container mb-5">
            <p class="mb-0 ml-3">
              <b>¿Está seguro que no desea continuar con esta integración?</b>
            </p>
            <span class="mb-0 ml-3">
              Esto implica que no se integrarán las columnas con <br />
              Blackboard alineadas hasta ahora
            </span>
          </div>
        </form>
      </div>
      <div class="modal-footer justify-content-center">
        <div class="my-4">
          <button
            class="boton-secundario ml-3"
            data-toggle="tooltip"
            data-placement="top"
            title="NO, CONTINUAR INTEGRACIÓN"
            alt="NO, CONTINUAR INTEGRACIÓN"
            data-dismiss="modal"
            id="btn-modal-salir-dismiss"
          >
            NO, CONTINUAR INTEGRACIÓN
          </button>
          <button
            class="boton_principal_modal ml-3"
            data-toggle="tooltip"
            data-placement="top"
            title="SALIR DE ESTA INTEGRACIÓN"
            alt="SALIR DE ESTA INTEGRACIÓN"
            data-dismiss="modal"
            (click)="volverInicio()"
          >
            SALIR DE ESTA INTEGRACIÓN
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- FIN MODAL ELIMINAR -->
<!-- MODAL CONFIRMAR -->
<button
  id="modal-confirmar"
  class="btn d-none"
  data-toggle="modal"
  data-target="#confirmar"
>
  CERRAR Confirmar Integración
</button>
<div
  class="modal fade"
  id="confirmar"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          title="CERRAR"
          alt="CERRAR"
        >
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div
            class="row align-items-center my-3 mx-4 text-container-confirmar"
          >
            <p class="mb-3" *ngIf="nColumnas > 0">
              Aún tiene
              <b
                >{{
                  nColumnas + " " + (nColumnas === 1 ? "columna" : "columnas")
                }}
              </b>
              {{
                nColumnas === 1
                  ? "en Portal de Calificaciones que no ha sido alineada"
                  : "en Portal de Calificaciones que no han sido alineadas"
              }}
              <br />
              <br />
              ¿Desea confirmar la integración realizada hasta ahora?
            </p>
            <p class="mb-3 alineacion-completa" *ngIf="nColumnas === 0">
              ¿Está seguro que desea confirmar la integración realizada hasta
              ahora? <br />
              Si confirma no podrá editar esta integración.
            </p>
          </div>
        </form>
      </div>
      <div class="modal-footer justify-content-center">
        <div class="my-4">
          <button
            class="boton-secundario ml-3"
            data-toggle="tooltip"
            data-placement="top"
            title="NO, CONTINUAR INTEGRANDO"
            alt="NO, CONTINUAR INTEGRANDO"
            data-dismiss="modal"
            id="btn-modal-salir-dismiss"
          >
            NO, CONTINUAR INTEGRANDO
          </button>
          <button
            class="boton_principal_modal ml-3"
            data-toggle="tooltip"
            data-placement="top"
            title="SI, CONFIRMAR"
            alt="SI, CONFIRMAR"
            data-dismiss="modal"
            (click)="crearIntegracion()"
          >
            SI, CONFIRMAR
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- FIN MODAL CONFIRMAR -->
